export default __webpack_public_path__ + "static/media/111_mobile.ad8c7377.jpg";